module.exports = __webpack_public_path__ + "img/kaspersky.3eb43f3e.svg";